module.exports = __webpack_public_path__ + "static/fonts/PorscheNextPersianTT-Bold.9a9e6a62.ttf";